export default {
  page: 1,
  modal: 2,
};
